export const AUTOHOFS_COMMAND_NODE = "get_autohofs"
export const AUTOHOFS_NS = "urn:slickshift:autohofs:0"

// Blue "P" marker rendered for every autohof on the map.
export const AUTOHOF_ICON_URL = "/fuel-icons/autohof.png"
export const AUTOHOF_ICON_IMAGE_ID = "autohof-icon"

export type Autohof = {
  lat: number
  lon: number
  name: string
  address: string
}
